export default __webpack_public_path__ + "static/media/Calko512.4e81c22a.png";